import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCabinet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cabinet"} maskId="square-filled-radius-0-stroke-1-IconCabinet"><path d="M11.5 4H2V12H4.20321L2.92676 19.914L3.914 20.0732L5.21613 12H11.5V4Z" fill="currentColor"/><path d="M19.7968 12H22V4H12.5V12H18.7839L20.086 20.0732L21.0732 19.914L19.7968 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCabinet;
